var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      attrs: {
        "is-visible": _vm.isVisible,
        "aria-label": _vm.imageModalHeading
      },
      on: {
        close: _vm.close,
        "click-overlay": _vm.close,
        "focus-start": _vm.focusStart
      }
    },
    [
      _c("div", { attrs: { slot: "content" }, slot: "content" }, [
        _c("div", { staticClass: "imageCarousel" }, [
          _c(
            "div",
            { staticClass: "carouselHeroContainer" },
            [
              _vm.selectedImage
                ? _c("transition", { attrs: { name: "carouselHeroFade" } }, [
                    _vm.selectedImage
                      ? _c(
                          "picture",
                          {
                            key: _vm.selectedIndex,
                            staticClass: "carouselHeroPicture"
                          },
                          [
                            _c("img", {
                              ref: "hero",
                              staticClass: "carouselHeroImage",
                              attrs: {
                                src: _vm.selectedImage.desktop,
                                alt: _vm.selectedImage.altText
                              }
                            })
                          ]
                        )
                      : _vm._e()
                  ])
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _vm.images && _vm.images.length > 0
            ? _c("div", { staticClass: "carouselNavigation" }, [
                _c("p", { staticClass: "carouselNavigationTitle" }, [
                  _vm._v(_vm._s(_vm.navigationTitle))
                ]),
                _vm._v(" "),
                _c(
                  "ul",
                  { staticClass: "carouselThumbnails" },
                  _vm._l(_vm.images, function(img, index) {
                    return _c(
                      "li",
                      {
                        ref: "thumbnails",
                        refInFor: true,
                        staticClass: "carouselThumbnail"
                      },
                      [
                        _c(
                          "button",
                          {
                            ref: "buttons",
                            refInFor: true,
                            staticClass: "thumbnailButton",
                            class: {
                              selectedThumbnail: index === _vm.selectedIndex
                            },
                            attrs: {
                              "aria-pressed": index === _vm.selectedIndex
                            },
                            on: {
                              click: function($event) {
                                _vm.selectImage(index)
                              }
                            }
                          },
                          [
                            _c("img", {
                              staticClass: "thumbnailImage",
                              attrs: { src: img.thumbnail, alt: img.altText }
                            })
                          ]
                        )
                      ]
                    )
                  }),
                  0
                )
              ])
            : _vm._e()
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }